<template>
  <div>
    <card v-loading="loading" :title="$t('offlineFilters.pageSingle.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <offline-filter-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import OfflineFilterDetails from "src/components/OfflineFilter/OfflineFilterDetails";
import {mapActions, mapState} from "vuex";

export default {
  name: 'OfflineFilterPage',
  components: {
    OfflineFilterDetails
  },
  methods: {
    ...mapActions(['LoadOfflineFilter'])
  },
  computed: {
    ...mapState({
      loading: state => state.offline_filter.loading,
      details: state => state.offline_filter.data,
      error: state => state.offline_filter.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadOfflineFilter({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
